<template>
  <div :class="['repeatableGroupReadOnly', definition.id, {'pulse': isLanguageSelected(object)}, {'w3-hide' : !aliasFoundOnPresentation() }, getRepeatableGroupPresentationAliasClass(definition.id)]">
    <label v-if="!hideLabel && definition.type !== 'image' && definition.type !== 'group' && definition.type !== 'conditional' && definition.type !== 'pdf'" :class="['label', {'hide':(getLabel(object) === null || getLabel(object) === '')}]">{{ getLabel(object) }}</label>
    <definition-text v-if="definition.type === 'text' || definition.type === 'longText'"
      :definition="definition"
      :object="object"
      :editable="false"
      :mandatoryValidation="null"
      :languageSelected="languageSelected"
      :showMultilanguage="showMultilanguage"
      :language="language"
      :visualDefinition="visualDefinition"
      :apiparams="apiparams"
      :definitionContentId="definitionContentId"
      :repeatableGroupCode="repeatableGroupCode"
      @newLanguageSelected="newLanguageSelected"
    />
    <!-- comment for 'definition.js' low size -->
    <definition-html v-else-if="definition.type === 'html'"
      :definition="definition"
      :object="object"
      :editable="false"
      :mandatoryValidation="null"
      :languageSelected="languageSelected"
      :tinyId="tinyId"
      :showMultilanguage="showMultilanguage"
      :language="language"
      :authorization="authorization"
      :type="type"
      :visuals="visuals"
      :apiparams="apiparams"
      :definitionContentId="definitionContentId"
      :repeatableGroupCode="repeatableGroupCode"
      :readOnly="true"
      :isSimpleHtml="isSimpleHtml(definition.id)"
      @newLanguageSelected="newLanguageSelected"
    />
    <definition-image v-else-if="definition.type === 'image'"
      :definition="definition"
      :object="object"
      :editable="false"
      :mandatoryValidation="null"
      :languageSelected="languageSelected"
      :showMultilanguage="showMultilanguage"
      :language="language"
      :authorization="authorization"
      :type="type"
      :definitionContentId="definitionContentId"
      :repeatableGroupCode="repeatableGroupCode"
      :visuals="visuals"
      :apiparams="apiparams"
      @newLanguageSelected="newLanguageSelected"
    />
    <definition-file v-else-if="definition.type === 'file'"
      :definition="definition"
      :object="object"
      :editable="false"
      :mandatoryValidation="null"
      :languageSelected="languageSelected"
      :showMultilanguage="showMultilanguage"
      :language="language"
      :authorization="authorization"
      :type="type"
      :definitionContentId="definitionContentId"
      :repeatableGroupCode="repeatableGroupCode"
      :visuals="visuals"
      :apiparams="apiparams"
      @newLanguageSelected="newLanguageSelected"
    />
    <definition-date v-else-if="definition.type === 'date' || definition.type === 'datetime' || definition.type === 'time' || definition.type === 'duration'"
      :definition="definition"
      :object="object"
      :editable="false"
      :mandatoryValidation="null"
      :languageSelected="languageSelected"
      :showMultilanguage="showMultilanguage"
      :language="language"
      :visualDefinition="visualDefinition"
      :authorization="authorization"
      :type="type"
      :definitionContentId="definitionContentId"
      :repeatableGroupCode="repeatableGroupCode"
      :visuals="visuals"
      :apiparams="apiparams"
      @newLanguageSelected="newLanguageSelected"
    />
    <definition-pdf v-else-if="definition.type === 'pdf'"
      :definition="definition"
      :object="object"
      :editable="false"
      :mandatoryValidation="null"
      :languageSelected="languageSelected"
      :showMultilanguage="showMultilanguage"
      :language="language"
      :authorization="authorization"
      :type="type"
      :definitionContentId="definitionContentId"
      :repeatableGroupCode="repeatableGroupCode"
      :visuals="visuals"
      :apiparams="apiparams"
      :withPdfViewer="false"
      :sendTmpPdf="true"
      @newLanguageSelected="newLanguageSelected"
    />
    <span v-else-if="definition.type !== 'group' && definition.type !== 'conditional'" class="read-only" v-html="getObjectTextValue()" />

    <div v-for="(childObj, childObjIndex) in getObjectWithChildren" :key="childObjIndex">
      <definition-repeatable-group-read-only
        :definitionId="definitionId" :definition="getRequestDefinitionById(childObj)" :object="childObj"
        :languageSelected="languageSelected" :index="index" :moment="moment" :language="language" :visualDefinition="visualDefinition"
        :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams"
        :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :repeatableGroupPresentation="repeatableGroupPresentation" @newLanguageSelected="newLanguageSelected"
      />
    </div>
  </div>
</template>

<script>
import transport from 'vue-definition-utils/src/utils/transport'
import DefinitionHtml from '../html' // comment for 'definition.js' low size
import DefinitionText from '../text'
import DefinitionImage from '../image'
import DefinitionFile from '../file'
import DefinitionPdf from '../pdf'
import DefinitionDate from '../date'

export default {
  name: 'definition-repeatable-group-read-only',
  props: [
    'definitionId',
    'definition',
    'object',
    'languageSelected',
    'index',
    'moment',
    'showMultilanguage',
    'language',
    'visualDefinition',
    'authorization',
    'type',
    'visuals',
    'apiparams',
    'definitionContentId',
    'repeatableGroupCode',
    'repeatableGroupPresentation',
    'hideLabel'
  ],
  components: {
    DefinitionHtml, // comment for 'definition.js' low size
    DefinitionText,
    DefinitionImage,
    DefinitionFile,
    DefinitionPdf,
    DefinitionDate
  },
  data () {
    return {
      tinyId: null,
      languageChanged: false
    }
  },
  beforeMount () {
    if (this.definition.type === 'html' && this.index && this.moment) {
      this.tinyId = this.definition.id + '_' + this.index + '_' + this.moment
    } else {
      this.tinyId = this.definition.id
    }
    /* @CEN */
    if (this.definition.type === 'pdf') {
      console.log('repeatable-group-read-only beforeMount PDF', this.definition.id)
    }
  },
  methods: {
    getObjectTextValue () {
      var languageSelectedKey = null
      if (this.languageSelected) {
        languageSelectedKey = this.languageSelected.key
      }
      return transport.methods.getObjectTextValue(this.visualDefinition.definition, this.definition, this.object, languageSelectedKey)
    },
    getLabel (object) {
      var label = ''
      var reqDef = transport.methods.getRequestDefinitionById(object.id, [this.definition])
      if (reqDef) {
        label = this.definition.label
      }
      return label
    },
    getRequestDefinitionById (object) {
      var result = null
      if (object) {
        result = transport.methods.getRequestDefinitionById(object.id, [this.definition])
      }
      return result
    },
    newLanguageSelected (language) {
      this.$emit('newLanguageSelected', language)
    },
    isLanguageSelected (object) {
      var reqDef = this.getRequestDefinitionById(object)
      return transport.methods.isMultiLanguage(reqDef) && this.languageChanged
    },
    aliasFoundOnPresentation () {
      var result

      if (this.definition.type === 'conditional') {
        result = true
      } else {
        result = true
        if (this.repeatableGroupPresentation && this.repeatableGroupPresentation.alias) {
          result = false
          for (var i = 0; i < this.repeatableGroupPresentation.alias.length && !result; i++) {
            result = (this.repeatableGroupPresentation.alias[i].id === this.definition.id)
          }
        }
      }

      return result
    },
    getRepeatableGroupPresentationAliasClass (id) {
      var result = null

      if (this.repeatableGroupPresentation && this.repeatableGroupPresentation.alias) {
        for (var i = 0; i < this.repeatableGroupPresentation.alias.length && !result; i++) {
          if (this.repeatableGroupPresentation.alias[i].id === id) {
            result = this.repeatableGroupPresentation.alias[i].class
          }
        }
      }

      return result
    },
    isSimpleHtml (id) {
      var cssClass = this.getRepeatableGroupPresentationAliasClass(id)
      return this.isInClassString('simple-html', cssClass)
    },
    isInClassString (classStr, allClasses) {
      var result = false
      if (allClasses) {
        var classes = allClasses.split(' ')
        if (classes && classes.length > 0) {
          for (var i = 0; i < classes.length && !result; i++) {
            result = (classes[i] === classStr)
          }
        }
      }
      return result
    }
  },
  computed: {
    getObjectWithChildren () {
      var result = null

      if (this.object && this.object.children) {
        result = []
        for (var i = 0; i < this.object.children.length; i++) {
          if (this.object.children[i]) {
            result.push(this.object.children[i])
          }
        }
      }

      return result
    }
  },
  watch: {
    languageSelected (languageSelected) {
      this.languageChanged = true
      var self = this
      setTimeout(function () {
        self.languageChanged = false
      }, 550)
    }
  }
}
</script>

<style lang="scss">
.repeatableGroupReadOnly {
  .mce-toolbar,
  .mce-toolbar-grp,
  .mce-statusbar {
    display: none;
  }
  .mce-edit-area {
      border-width:0 0 0 !important;
  }
  .definition-wrapper {
    width: initial;
    display: inline;

    &.image {
      min-height: 438px !important;
      display: block;
    }
  }

  .image {
    img {
      width: 100%;
    }
  }

  &.marginTop {
    margin-top: 15px;
  }

  iframe {
    background-color: #fafafa;
    border: 1px solid #e0e0e0 !important;
    margin-top: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/content/definitionLoader/item/repeatableGroup/repeatableGroupReadOnly.vue